
import { Component, OnInit, DoCheck } from '@angular/core';
import '../../assets/libs/d3.v3.min.js';
import '../../assets/libs/solar-calculator.js';
import {GeoService} from '../geo/geo.service';
import {BrujulaService} from './brujula.service';
import {FchartalgoService} from '../fchart/fchartalgo.service';

@Component({
  selector: 'app-ubicacion',
  templateUrl: './ubicacion.component.html',
  styleUrls: ['./ubicacion.component.scss']
})
export class UbicacionComponent implements OnInit, DoCheck {

  province;

  constructor(private brujula: BrujulaService, private geo: GeoService, private fchartalgo: FchartalgoService) {

  }

  ngDoCheck() {
    if(this.province != this.fchartalgo.getSelectedProvince()){
      this.province = this.fchartalgo.getSelectedProvince();
      var date = new Date();
      this.province.current_rad = this.province.average_radiation[date.getMonth()];
      this.province.current_temp = this.province.average_temperature[date.getMonth()];
      this.brujula.buildVisualization(this.province);
    }
  }

  ngOnInit() {

  }


}



// WEBPACK FOOTER //
// ./src/app/ubicacion/ubicacion.component.ts